import { render, staticRenderFns } from "./GalleryBanner.vue?vue&type=template&id=3d68f23d&scoped=true&"
import script from "./GalleryBanner.vue?vue&type=script&lang=js&"
export * from "./GalleryBanner.vue?vue&type=script&lang=js&"
import style0 from "./GalleryBanner.vue?vue&type=style&index=0&id=3d68f23d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d68f23d",
  null
  
)

export default component.exports